var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "top", appear: "" } },
    [
      _c(
        "q-page-sticky",
        { attrs: { position: "top-right", offset: [18, 18] } },
        [
          _c(
            "q-btn",
            {
              attrs: {
                round: "",
                small: "",
                outline: "",
                color: "primary",
                icon: "clear"
              },
              on: { click: _vm.goView }
            },
            [
              _c(
                "q-tooltip",
                {
                  attrs: {
                    self: "center right",
                    anchor: "center left",
                    delay: 500
                  }
                },
                [_vm._v("Отменить")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-btn",
            {
              attrs: {
                round: "",
                small: "",
                color: "warning",
                icon: "done",
                disabled: _vm.notChanged
              },
              on: { click: _vm.doSave }
            },
            [
              _c(
                "q-tooltip",
                {
                  attrs: {
                    self: "center right",
                    anchor: "center left",
                    delay: 500
                  }
                },
                [_vm._v("Сохранить")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(">\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2fc5408", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2fc5408","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/save-btn.vue
// module id = null
// module chunks = 